<button (click)="openPanel(menuRef)" aria-label="Menu icon" color="primary" mat-icon-button [disabled]="elaborazioneService.isCheckingElaborazione()">
  <mat-icon class="material-symbols-outlined">menu</mat-icon>
</button>
<ng-template #menuRef>
  <app-menu-panel [menu]="menu"></app-menu-panel>
</ng-template>
